export default "__VITE_ASSET__DN1sK5b8__"